// extracted by mini-css-extract-plugin
export default {"solutions":"Solutions_solutions__EeBZc","solutionsTxt":"Solutions_solutionsTxt__X+ArT","blocs":"Solutions_blocs__2YlNC"};